<script>
export default {
    name: "ItemIssueHistory",

    props: {
        showModal: Boolean,
        item: {
            type: Object,
            required: true,
        },
        itemIssueHistory: {
            type: Array,
            required: true,
        },
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-2/3 w-11/12">
  <template v-slot:title>
    <h5 class="font-medium text-sm">Item Issue History</h5>
  </template>
  <template v-slot:modal-body>
    <div class="w-full flex flex-wrap items-center">
        <div class="w-full p-1">
            <h5 class="text-sm font-medium">{{ item.service }}</h5>
        </div>
        <div class="w-full overflow-auto">
            <table class="table text-xs">
                <thead class="bg-blue-500 text-white">
                    <tr>
                        <th class="p-tiny">Date</th>
                        <th class="p-tiny">Patient</th>
                        <th class="p-tiny">Item</th>
                        <th class="p-tiny">Requested Qty</th>  
                        <th class="p-tiny">Issued Qty</th> 
                         <th class="p-tiny">Remaining Qty</th>
                    </tr>
                </thead>
                <tbody class="bg-gray-100">
                    <tr v-for="(itemIssue, idx) in itemIssueHistory" :key="idx">
                        <td class="p-tiny">{{ itemIssue.date | dateFormat }}</td>
                        <td class="p-tiny">
                            <h5>Names: {{ itemIssue.names }}</h5>
                            <h5>MRN: {{ itemIssue.patientID}}</h5>
                            <h5>Type: 
                                {{ 
                                    itemIssue.iS_IN_PATIENT == 'True' ? `Inpatient` : `Outpatient`
                                }}
                            </h5>
                        </td>
                        <td class="p-tiny">{{ itemIssue.item }}</td>
                        <td class="p-tiny">{{ itemIssue.requestedQty }}</td>
                        <td class="p-tiny">{{ itemIssue.qtyIssued }}</td>
                        <td class="p-tiny">{{itemIssue.requestedQty- itemIssue.qtyIssued }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button 
        class="btn-danger btn-sm text-xs rounded" 
        @click.prevent="$emit(`closeModal`)"><i class="fa fa-times"></i> Close</button>
  </template>
</tail-modal>
</template>